export const FigPalette = {
  Transparent: 'transparent',
  White: '#ffffff',
  Black: '#000000',
  Error: '#dc041f',
  Grey: {
    $50: '#fafafa',
    $100: '#f5f5f5',
    $200: '#e0e0e0',
    $300: '#c4c4c4',
    $400: '#adadad',
    $500: '#8a8a8a',
    $600: '#666666',
    $700: '#4f4f4f',
    $800: '#363636',
    $900: '#141414',
  },
  Watermelon: {
    $100: '#fee6e9',
    $200: '#fecdd3',
    $300: '#fda5b0',
    $400: '#fc7d8d',
    $500: '#fc5569',
    $600: '#dc041f',
    $700: '#a50317',
    $800: '#69020f',
    $900: '#4b010a',
  },
  Orange: {
    $100: '#ffeedc',
    $200: '#fedeb8',
    $300: '#fec88b',
    $400: '#fdba6d',
    $500: '#fc9012',
    $600: '#ed8003',
    $700: '#bb6502',
    $800: '#884a02',
    $900: '#422301',
  },
  Sun: {
    $100: '#fef7c2',
    $200: '#fef5ae',
    $300: '#fef190',
    $400: '#feec6c',
    $500: '#fde111',
    $600: '#eed102',
    $700: '#bba502',
    $800: '#796b01',
    $900: '#423a01',
  },
  Pistachio: {
    $100: '#e6fccf',
    $200: '#bff881',
    $300: '#a3f64c',
    $400: '#88f316',
    $500: '#6ecb0b',
    $600: '#59a509',
    $700: '#447e07',
    $800: '#2f5705',
    $900: '#203a03',
  },
  Aqua: {
    $100: '#d2f9e7',
    $200: '#a7f3d0',
    $300: '#81eebc',
    $400: '#54e8a4',
    $500: '#28e28c',
    $600: '#1abc72',
    $700: '#138b54',
    $800: '#0d633b',
    $900: '#062d1b',
  },
  Cyan: {
    $100: '#d8fafe',
    $200: '#abf4fc',
    $300: '#83eefb',
    $400: '#44e6f9',
    $500: '#08d5ed',
    $600: '#07bfd4',
    $700: '#058e9e',
    $800: '#04626d',
    $900: '#023136',
  },
  Blue: {
    $100: '#e1eeff',
    $200: '#bfdbfe',
    $300: '#a0cafd',
    $400: '#7cb5fd',
    $500: '#549ffc',
    $600: '#137afb',
    $700: '#0356bf',
    $800: '#02479c',
    $900: '#01295a',
  },
  Cornflower: {
    $50: '#f5f7ff',
    $100: '#e6ebfe',
    $200: '#c7d2fe',
    $300: '#a0b2fd',
    $400: '#738efc',
    $500: '#5a7afc',
    $600: '#2852fb',
    $700: '#0329be',
    $800: '#031e8c',
    $900: '#010f46',
  },
  Lavender: {
    $100: '#f4ebff',
    $200: '#e9d5ff',
    $300: '#d4adff',
    $400: '#ba7aff',
    $500: '#a757ff',
    $600: '#7c05ff',
    $700: '#5c00c2',
    $800: '#42008a',
    $900: '#2c005c',
  },
} as const;
